import notifyError from './notify-error.js';

const notifyResponseException = ({ $vs, data }) => {
  notifyError({ $vs, title: data.exception, text: data.message });
  const responseBody = data?.response?.body;
  responseBody && notifyError({ $vs, title: responseBody.exception, text: responseBody.message });
};

const notifyErrorResponse = ({ $vs, response }) => {
  if (response?.data?.exception) {
    notifyResponseException({ $vs, data: response.data });
    return;
  }

  const error = response?.data?.error;

  // Generic (non-validation) backend errors come back as a plain string message
  // (MicroserviceExceptionsHandler::errorResponse($message, $code) across all
  // microservices) — only true validation errors are shaped as {field: [messages]}.
  // Object.keys() on a string returns its character indices (not an empty array),
  // so without this check the code below misidentifies a string as the validation
  // shape and crashes trying to .forEach() a single character.
  if (typeof error === 'string') {
    notifyError({ $vs, text: error });
    return;
  }

  const models = Object.keys(error || {});

  if (0 === models.length) {
    notifyError({ $vs, text: response?.data || response.statusText });
    return;
  }

  models.forEach((model) => {
    if (Array.isArray(error[model])) {
      error[model].forEach((text) => notifyError({ $vs, text }));
      return;
    }

    Object.keys(error[model]).forEach((property) => {
      error[model][property].forEach((text) => notifyError({ $vs, text }));
    });
  });
};

export default ({ $vs, error }) => {
  if (error?.response) {
    notifyErrorResponse({ $vs, response: error.response });
    return;
  }

  if (error?.message) {
    notifyError({ $vs, text: error.message });
    return;
  }

  notifyError({ $vs, text: error });
}
